import Link from 'next/link';

import { CHAIN_EXPLORER_NAMES, CHAIN_IDS } from '@/constants/chain';

import { fontStyles } from '@/styles/typography';

import { getBlockExplorerTransactionURL } from '@/utils/blockExplorers';
import { routes } from '@/utils/routes';

type TradeToastDetailsLinkProps = {
  chainId: number;
  hash: string;
  onDismiss: () => void;
  label?: string;
  useBlockExplorer?: boolean;
};

const detailsLinkStyle = fontStyles({
  variant: 'LABEL_MD',
  class: [
    'text-token-purple-900 cursor-pointer p-1.5 -ml-1 rounded-[8px] hover:bg-token-purple-200',
    'hover:bg-token-purple-200 active:bg-token-purple-200 focus:outline-none focus-visible:ring-2',
    'focus-visible:ring-token-purple-500 transition-all duration-150 ease-in-out',
  ],
});

export const TradeToastDetailsLink = ({
  chainId,
  hash,
  onDismiss,
  label = 'View trade detail',
  useBlockExplorer = false,
}: TradeToastDetailsLinkProps) => {
  const showBlockExplorer = useBlockExplorer || chainId === CHAIN_IDS.SOLANA;

  return showBlockExplorer ? (
    <a
      className={detailsLinkStyle}
      href={getBlockExplorerTransactionURL(chainId, hash)}
      onClick={onDismiss}
      target="_blank"
      rel="noopener noreferrer"
    >
      View on {CHAIN_EXPLORER_NAMES[chainId]}
    </a>
  ) : (
    <Link
      className={detailsLinkStyle}
      onClick={onDismiss}
      href={{
        pathname: routes.TX,
        query: { chainId: String(chainId), txHash: hash },
      }}
    >
      {label}
    </Link>
  );
};
